import React, { Component } from 'react';
import {toJS, observable, autorun} from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'recompose';
import {withAuthorization} from './utils/auth';
import RequestForm from "./RequestForm";

import { Table, Spin, Input, Button, Tag, Icon, Divider, Modal } from "antd";
import moment from 'moment';

import { Document, Collection } from 'firestorter';
@observer
class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: null,
      transactionsP: null,
      transactionsW: null,
      selection: [],
      users: {},
      loading: false,
      visible: false
    }
    this.dispose = undefined;
    this.distrans = undefined;
    this.doDelete = this.doDelete.bind(this);
    this.getDocs = this.getDocs.bind(this);
    this.getUser = this.getUser.bind(this);

    this.props.userStore.requests.query =  this.props.userStore.requests.ref.orderBy('startDate', 'desc');
    this.createRequest = this.createRequest.bind(this);
    this.requests = this.props.data || new Collection('contracts');
    //this.props.userStore.transactions.query = this.props.userStore.transactions.ref.where("type", "==", "payin").where("requestStartTime", "<=", moment().endOf('week').unix());
    this.createTransaction = this.createTransaction.bind(this);
    this.transactionsWeekly = new Collection('transactions', {mode: 'on'});
    this.transactionsWeekly.query = this.transactionsWeekly.ref.where("type", "==", "weeklyPayin");
    this.transactionsPayin = new Collection('transactions', {mode: 'on'});
    this.transactionsPayin.query = this.transactionsPayin.ref.where("type", "==", "payin");
  }

  componentDidMount() {
    if (this.state.requests == null) {
      // this.setState({ loading: true });
      this.dispose = autorun(() => {
        // this.request = this.requestDocument.data;

        this.setState({ requests: this.requests.docs });
        //console.log("{request}", this.requests.docs);
      });

      // var requests = null;

      // this.setState({ loading: false });
    }
    if (this.state.transactionsP == null && this.state.transactionsW == null) {
      this.distrans = autorun(async () => {
        let tmp = [];
        //doing a filter would be smarter
        await this.transactionsPayin.docs.map((doc, i) => {
          if (!moment(doc.data.requestStartTime).isAfter(moment().endOf('week'))) {
            tmp.push(doc);
          }
        });
        this.setState({
          transactionsP: tmp,
          transactionsW: this.transactionsWeekly.docs,
        });
        //console.log("{transactions}", this.transactions.docs);
      });
    }
  }
  componentWillUnmount(){
    this.setState(null);
    this.dispose();
    this.distrans();
  }
  getDocs(docs, trans) {
    //console.log("GET DOCS=", trans.tP ? trans.tP.length : 0);
    var userIds = [];
    if(docs) {
      var returnDocs = docs.map((doc, i) => {
        let pay = false;
        if(userIds.indexOf(doc.data.nurse.id) < 0){
          userIds.push(doc.data.nurse.id)
        }
        if(userIds.indexOf(doc.data.author) < 0){
          userIds.push(doc.data.author);
        }
        if (!doc.data.isRecurring) {
          //trans.tP
          //this.transactionsPayin.query = this.transactionsPayin.ref.where("type", "==", "payin").where("contractId", "==", doc.id);
          for (let i = 0; i < trans.tP.length; i++) {
            if (trans.tP[i].data.contractId == doc.id && trans.tP[i].data.processed != false) {
              pay = true;
            }
          };
        }
        if (doc.data.isRecurring) {
          //trans.tw
          for (let i = 0; i < trans.tP.length; i++) {
            if (trans.tP[i].data.contractId == doc.id && trans.tP[i].data.processed != false &&
                (
                  moment().subtract(7, 'days').startOf('week').isBefore(moment(doc.data.startTime)) &&
                  moment().subtract(7, 'days').endOf('week').isAfter(moment(doc.data.startTime))
                )
               ) {
              //console.log(`the ${doc.data.isRecurring ? 'recurring' : 'ponctual'} contract ${doc.id} with nurse ${doc.data.nurse.email} has been processed`);
              pay = true;
            }
            if (trans.tP[i].data.contractId == doc.id && trans.tP[i].data.processed == false) {
              //console.log(`the ${doc.data.isRecurring ? 'recurring' : 'ponctual'} contract ${doc.id} with nurse ${doc.data.nurse.email} has NOT been processed`);
            }
          };
          for (let i = 0; i < trans.tW.length; i++) {
            if (trans.tW[i].data.contractId == doc.id && trans.tW[i].data.processed != false &&
                (
                  moment().subtract(7, 'days').startOf('week').isBefore(moment(doc.data.startTime)) &&
                  moment().subtract(7, 'days').endOf('week').isAfter(moment(doc.data.startTime))
                )
               ) {
              pay = true;
            }
          }
        }

        return ({
            key: i,
            duration: doc.data.duration,
            nurse: {
              email: doc.data.nurse.email,
              id: doc.data.nurse.id,
            },
            author: {
              email: doc.data.author,
              id: doc.data.author
            },
            tasks: doc.data.tasks,
            startTime: doc.data.startTime,
            startDate: doc.data.isRecurring ? doc.data.startDate : doc.data.startTime,
            isRecurring: doc.data.isRecurring,
            pay: pay,
            id: doc.id,
            doc: doc
          })
        });
          // console.log("userIds: ", userIds);
          userIds.map( async (userId) => {
            return await this.getUser(userId);
          });
          return returnDocs;
        } else {
          return null
        }
    // this.setState({requests: docs});
    // return docs;
  }
  selector = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      this.setState({selection: selectedRows});
    },
    // getCheckboxProps: record => ({ // Disable checkbox on ADMIN USER
    //   disabled: record.role === 'admin'
    // }),
  }
  async createRequest(data) {
    this.setState({loading: true});
    console.log("WE CALLED CREATE REQUEST");
    const doc = await this.props.userStore.requests.add(data);
    this.setState({loading: false});
  }
  async createTransaction(data) {
    this.setState({loading: true});
    console.log("WE CALLED CREATE TRANSACTIONS");
    const trans = await this.props.userStore.transactions.add(data);
    this.setState({loading: false});
  }
  doDelete(){
    this.setState({loading: true});
    this.state.selection.map(async (data) => {
      await data.doc.delete();
    })
    this.setState({loading: false});
  }
  renderTag = (value) => {
    var results = [];

    value.map((tag, i) => {
      results.push(<Tag key={i} color="purple">{tag}</Tag>);
    })
    return results
  }
  getUser(userId) {
    return new Promise(async (resolve, reject) => {
      if(!this.state.users[userId]){
        var userDocument = new Document("users/" + userId, {
          mode: "off"
        });
        const user = await userDocument.fetch();
        if(user.data) {
          var prev = {...this.state.users};
          prev[userId] = user.data;
          this.setState({users: prev});
        } else {
          var prev = {...this.state.users};
          prev[userId] = {
            firstname: 'Utilisateur',
            lastname: 'Supprimé'
          };
          this.setState({users: prev});
        }
      }
      resolve();
    });
  }
  //
  // async getUser(userId) {
  //   if(!this.state.users[userId]){
  //     var userDocument = new Document("users/" + userId, {
  //       mode: "off"
  //     });
  //     const user = await userDocument.fetch();
  //     if(user.data) {
  //       var prev = {...this.state.users};
  //       prev[userId] = user.data;
  //       this.setState({users: prev});
  //     } else {
  //       var prev = {...this.state.users};
  //       prev[userId] = {
  //         firstname: 'Utilisateur',
  //         lastname: 'Supprimé'
  //       };
  //       this.setState({users: prev});
  //     }
  //
  //   }
  // }
  doStringSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null){
      return 0;
    }
    if(a === undefined || a === null){
      console.log('A is Null', a);
      return -1;
    }
    if(b === undefined || b === null){
      console.log('B is Null', b);
      return -1;
    }

    return a.localeCompare(b);
  }
  doDateSort(a, b){
    if(a === undefined && b === undefined || b === null && a === null){
      return 0;
    }
    if(a === undefined || a === null){
      console.log('A is Null', a);
      return -1;
    }
    if(b === undefined || b === null){
      console.log('B is Null', b);
      return -1;
    }
    if(moment(a).isBefore(moment(b))){
      return -1;
    }
    if(moment(a).isAfter(moment(b))){
      return 1;
    }
    return 0;
  }

  sortByName(idA, idB) {
    
    const personA = this.state.users[idA];
    const personB = this.state.users[idB];
    if (!personA || !personB)
      return 0;
    return this.doStringSort(
      personA.firstname + personA.lastname,
      personB.firstname + personB.lastname
    );
  }

  render() {
    return (
      <div>
        <h1>Contrats</h1>
          <br/>
          <Spin spinning={toJS(this.props.userStore.requests.fetching && this.props.userStore.transactions.fetching)} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}>
          <Table
            dataSource={this.getDocs(this.state.requests, { tP: this.state.transactionsP, tW: this.state.transactionsW})}
            columns={[
              { title: "Client", dataIndex: "author", key: "author", width: '25%', sorter: (a, b) => this.sortByName(a.author.id, b.author.id), render: value => {
                // this.getUser(value.id)
                if(this.state.users[value.id]){
                  return (<Link to={'/users/'+value.id}>{this.state.users[value.id].firstname} {this.state.users[value.id].lastname}</Link>)
                } else {
                  return (<a>Chargement...</a>)
                }
              }},
              { title: "Intervenant", dataIndex: "nurse", key: "nurse", width: '25%', sorter: (a, b) => this.sortByName(a.nurse.id, b.nurse.id), render: (value) => {
                // this.getUser(value.id)
                if(this.state.users[value.id]){
                  return (<Link to={'/users/'+value.id}>{this.state.users[value.id].firstname} {this.state.users[value.id].lastname}</Link>)
                } else {
                  return (<a>Chargement...</a>)
                }
              } },
              { title: "Récurrent?", dataIndex: "isRecurring", key: "isRecurring", width: '15%', sorter: (a,b) => a.isRecurring ? 1 : -1,  render: value => value ? 'oui' : 'non' },
              { title: "Paiement", dataIndex: "pay", key: "pay", width: '15%', sorter: (a,b) => a.pay ? 1 : -1,  render: value => value ? 'oui' : 'non' },
              { title: "Date de début", dataIndex: "startDate", defaultSortOrder: "ascend", key: "startDate", width: '20%', sorter: (a,b) => this.doDateSort(a.startDate, b.startDate), render: value => moment(value).format('HH[h]mm DD-MM-YYYY')},
              // { title: "Tâches", dataIndex: "tasks", width: '10%', render: this.renderTag, key: "tasks", filters: [
              //   {text: 'Ménage', value: 'Ménage'},
              //   {text: 'Courses', value: 'Courses'},
              //   {text: 'Entretien du linge', value: 'Entretien du linge'},
              //   {text: 'Promenade', value: 'Promenade'},
              //   {text: 'Repas', value: 'Repas'},
              //   {text: 'Aide à la toilette', value: 'Aide à la toilette'},
              //   {text: 'Aide au lever', value: 'Aide au lever'},
              //   {text: 'Aide au coucher', value: 'Aide au coucher'},
              //   {text: 'Compagnie de jour', value: 'Compagnie de jour'},
              //   {text: 'Compagnie de nuit', value: 'Compagnie de nuit'}
              // ], onFilter: (val, record) => {return record.tasks ? (record.tasks.indexOf(val) === 0) : false } },
              { title: 'Action', render: (value, item) => {
                return (
                <Button
                  style={{ margin: 5 }}
                  type="primary"
                  href={'/contracts/'+item.id}
                >Voir</Button>
              )}}
            ]} />
          </Spin>
      </div>
    )
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer
)(Contracts);



// WEBPACK FOOTER //
// ./src/Contracts.js